"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AccordionConstructor = function (accordion) {
    var AccordionConfig = {
        openItem: false,
        limitOpenItems: true
    };
    var items = Array.from(accordion.querySelectorAll('.Accordion__item'));
    var openItem = function (itemProp) {
        var height = itemProp[0], item = itemProp[1], bodyWrap = itemProp[2];
        bodyWrap.style.height = height + 'px';
        item.classList.add('is-expanded');
        item.classList.remove("not-expanded");
        AccordionConfig.openItem = itemProp;
    };
    var closeItem = function (itemProp) {
        var height = itemProp[0], item = itemProp[1], bodyWrap = itemProp[2];
        bodyWrap.style.height = 0 + 'px';
        item.classList.add('not-expanded');
        item.classList.remove('is-expanded');
    };
    var itemIsOpen = function (item) { return item.classList.contains('is-expanded'); };
    var toggleItem = function (itemProp) {
        var isOpen = itemIsOpen(itemProp[1]);
        // If it is open then just close it, no worries
        if (isOpen) {
            return closeItem(itemProp);
        }
        // Otherwise we need to open an item, but first close the open one
        if (AccordionConfig.openItem && AccordionConfig.limitOpenItems) {
            closeItem(AccordionConfig.openItem);
        }
        // Open the item
        openItem(itemProp);
    };
    var prepareItem = function (item) {
        var bodyWrap = item.querySelector('.Accordion__item__bodyWrap');
        if (!bodyWrap) {
            return;
        }
        var height = bodyWrap.clientHeight;
        var itemProp = [height, item, bodyWrap];
        var itemTitle = item.querySelector('.Accordion__item__title');
        itemTitle.addEventListener('click', function () { return toggleItem(itemProp); });
        bodyWrap.style.height = 0 + 'px';
        bodyWrap.style.overflow = 'hidden';
    };
    items.forEach(prepareItem);
    return accordion;
};
exports.default = (function () {
    var accordions = Array.from(document.querySelectorAll('[data-accordion]'));
    return accordions.map(AccordionConstructor);
});
